import {useQuery} from "react-query";
import * as api from "../api/easeedesk/apis";

const getCustomFields = async (ticketId) => {
    return await api.fetchTicketCustomFields(ticketId);
};

export default function useTicketCustomFields(ticketId) {
    return useQuery([
        'ticket_custom_fields',
        {ticketId}
    ], () => getCustomFields(ticketId), {refetchOnWindowFocus: false});
}
